export type CdpEventParameters = {
  auds         ?: string,
  [key: string] : string | undefined
}